module.exports = {
  local: {
    BACKEND_URL: 'http://operation-local.aupup.com/',
    AGENT_ID: '1000062'
  },
  dev: {
    BACKEND_URL: 'http://operation-dev.aupup.com/',
    AGENT_ID: '1000043'
  },
  uat: {
    BACKEND_URL: 'https://operation-uat.aupup.com/',
    AGENT_ID: '1000043'
  },
  prod: {
    BACKEND_URL: 'https://operation.aupup.com/',
    AGENT_ID: '1000042'
  }
}
